import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: false,
})
/**
 * Bypass security and trust the given value to be a safe resource URL
 */
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({
  name: 'normalizeUrl',
  standalone: false,
})
export class NormalizeUrl implements PipeTransform {
  transform(redirectUrl: string): string {
    if (!redirectUrl) {
      return '';
    }

    if (
      redirectUrl.startsWith('http://') ||
      redirectUrl.startsWith('https://') ||
      redirectUrl.startsWith('/')
    ) {
      return redirectUrl;
    }

    return 'https://' + redirectUrl;
  }
}
